import React, { useEffect, useState } from "react";
import { AdminContact } from "../types/admin";
import { contactsApi } from "../services/api";

interface SocialIconsProps {
  className?: string;
}

const SocialIcons: React.FC<SocialIconsProps> = ({ className = "" }) => {
  const [contacts, setContacts] = useState<AdminContact[]>([]);

  useEffect(() => {
    const loadContacts = async () => {
      try {
        const response = await contactsApi.getAll({ pageSize: 100 });
        if (response.success && response.data) {
          setContacts(response.data);
        }
      } catch {
        // silently fail
      }
    };

    void loadContacts();
  }, []);

  if (contacts.length === 0) return null;

  return (
    <div className={className}>
      {contacts.map((contact) => (
        <a
          key={contact.id}
          href={contact.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`social-link ${contact.platform.toLowerCase()}`}
          aria-label={contact.label || contact.platform}
        >
          <i className={contact.iconClass} />
        </a>
      ))}
    </div>
  );
};

export default SocialIcons;
